import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { PLATFORM_LOGOS } from '@/features/connections/components/platform-logos';

/** Logotipo oficial da plataforma na aba (`platform-logos.ts`); sem ele, a inicial. */
export function PlatformMark({ provider }: { provider: string }) {
  return (
    <Avatar className="size-5 rounded-sm">
      <AvatarImage src={PLATFORM_LOGOS[provider]} alt="" />
      <AvatarFallback className="rounded-sm text-xs">
        {provider.slice(0, 1).toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
}
